<template>
	<div class="barWrap">
		<!-- 顶部 -->
		<Top></Top>
		<div class="bottom">
			<!-- 左侧 -->
			<Left></Left>
			<!-- 右侧 -->
			<div class="rightcontent">
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	import Top from './topnav.vue'
	import Left from './leftnav.vue'
	export default{
		components:{Top,Left}
	}
</script>

 <style lang="scss">
	.bottom{
		width: 100%;
		height: 100%;
		position: fixed;
		display: flex;
		justify-content: space-between;
		left: 0;
		top: 0px;
		padding-top: 60px;
		box-sizing: border-box;
		.rightcontent{
			height: 100%;
			overflow: hidden;
			flex: 1;
			.el-table td, .el-table th{
				padding: 5px 0 !important;
			}
		}
	}
 </style>